import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postResetPassword = async ({ payload, token }) => {
  const { data } = await SigliveServiceV1({
    method: 'POST',
    url: `/reset-password/${token}`,
    data: payload,
  });

  return data;
};

export default postResetPassword;
